import { ITypedReduxAction } from '../../types/redux/actionType';

export enum EChatWindowActionTypes {
  OpenChat = 'ChatWindow/openChat',
  CloseChat = 'ChatWindow/closeChat',
  ResetChat = 'ChatWindow/resetChat',
  IncreaseCountClosedChats = 'ChatWindow/increaseCountClosedChats',
}

export type TChatWindowActions =
  | ITypedReduxAction<EChatWindowActionTypes.OpenChat, string>
  | ITypedReduxAction<EChatWindowActionTypes.CloseChat>
  | ITypedReduxAction<EChatWindowActionTypes.ResetChat>
  | ITypedReduxAction<EChatWindowActionTypes.IncreaseCountClosedChats>;
